<ion-card-subtitle [class]="cssClass()">
  <ng-content />
</ion-card-subtitle>
